import { render, staticRenderFns } from "./Valuations.vue?vue&type=template&id=64e43bd2&scoped=true"
import script from "./Valuations.vue?vue&type=script&lang=js"
export * from "./Valuations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e43bd2",
  null
  
)

export default component.exports